import { supportQueryKeys as e } from "./supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/useMyCallbacksQuery.ts
var r = () => t({
	queryKey: e.myCallbacks(),
	queryFn: () => n.listMyCallbacks()
});
//#endregion
export { r as useMyCallbacksQuery };
